import { CartLinesUpdateEvent } from '@shopify/events';

// Mirrors kaw-product-view.js's own add-to-cart flow (plain form, no Horizon
// product-form-component) so the collection grid's cart icon behaves and
// animates identically to the PDP's native "Add to Cart" button.
const init = () => {
  document.querySelectorAll('[data-kaw-card-cart-form]').forEach((form) => {
    if (form.dataset.kawReady) return;
    form.dataset.kawReady = 'true';

    const button = form.querySelector('button[type="submit"]');
    const animationEnabled = form.dataset.kawAddToCartAnimation === 'true';

    const animateFlyToCart = () => {
      // More than one cart icon can exist at once (desktop utility bar + mobile header), only
      // one visible per breakpoint - an offscreen/hidden one would send the animation nowhere near it.
      const cartIcon = [
        ...document.querySelectorAll('[data-kaw-cart-icon], .header-actions__cart-icon'),
      ].find((el) => el.getClientRects().length > 0);
      const image = form.closest('.kaw-collection-view__card')?.querySelector('.kaw-collection-view__card-media img');
      if (!cartIcon || !image) return;

      const flyToCartElement = document.createElement('fly-to-cart');
      flyToCartElement.classList.add('fly-to-cart--quick');
      flyToCartElement.style.setProperty('background-image', `url(${image.currentSrc || image.src})`);
      flyToCartElement.style.setProperty('--start-opacity', '0');
      flyToCartElement.useSourceSize = true;
      flyToCartElement.sourceScale = 1.2;
      flyToCartElement.source = image;
      flyToCartElement.destination = cartIcon;

      document.body.appendChild(flyToCartElement);
    };

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (button?.disabled) return;

      if (button) button.disabled = true;
      if (animationEnabled) animateFlyToCart();

      const formData = new FormData(form);
      const quantity = parseInt(formData.get('quantity'), 10) || 1;
      const deferred = CartLinesUpdateEvent.createPromise();

      document.dispatchEvent(
        new CartLinesUpdateEvent({
          action: 'add',
          context: 'product',
          lines: [{ merchandiseId: formData.get('id'), quantity }],
          promise: deferred.promise,
        })
      );

      try {
        const addResponse = await fetch(`${form.action}.js`, {
          method: 'POST',
          body: formData,
          headers: { Accept: 'application/json' },
        });
        const added = await addResponse.json();
        if (!addResponse.ok) throw new Error(added.description || added.message || 'Add to cart failed');

        const cartResponse = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
          headers: { Accept: 'application/json' },
        });
        const cart = await cartResponse.json();

        deferred.resolve({
          cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
          detail: { items: cart.items, itemCount: cart.item_count, source: 'kaw-collection-card' },
        });
      } catch (error) {
        deferred.reject(error);
        console.error('[kaw-collection-card] add to cart failed:', error);
      } finally {
        if (button) button.disabled = false;
      }
    });
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init, { once: true });
} else {
  init();
}
document.addEventListener('shopify:section:load', init);
